/**
 * Example amble for UK - replace with actual content and delete this
 * TODO: replace with actual content and delete this (when deleting make sure stories still work)
 */
export const amble = `<p>This is an example UK amble.</p>`;
